































import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import UUIFComponent from '@/shared/uuifComponent';
import { SwTextarea } from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import { SelectOption } from '@sonicwall/unified-ui-framework/src/shared/sw-select';
import SecureUpdate from './secure-update.vue';
import { InfoState } from '@/core/core.store';
const cssPrefix = 'register-product-reg';

@Component({
  components: {
    ...UUIFComponent,
    SwTextarea,
    SecureUpdate,
  },
})
export default class SecureUpgradeWraper extends SwExtendedVue {
  cssPrefix = cssPrefix;
  @Prop()
  secureupgradecontent: any;
  @Prop()
  field : any;
  @Prop()
  noOfFields : any;
  @Prop()
  selectedSerialNumber: any;
  secureUpdateOptions : SelectOption[] = [];
  secupdateContent : any;
  secureUpdate: string = '';
  showSecureUpdateModal:boolean = false;
  secUpdatePage : string = '';
  secureUpdateSno : string = '';
  isSecureUpgrade : boolean = false;
  isStorageSata : boolean = false;
  isFreeTrail : boolean = false;
  created() {
    console.warn(this.field);
    if (this.secureupgradecontent.content.issecureupgrade) {
      this.isSecureUpgrade = true;
    } else if (this.secureupgradecontent.content.isstoragesata) {
      this.isStorageSata = true;
    } else {
      this.isFreeTrail = true;
    }
    this.loadData();
  }

  loadData() {
    this.secureUpdateOptions = [];
    this.secupdateContent = this.secureupgradecontent;
    this.secureUpdateOptions.push({
      id : 'default',
      label: this.isSecureUpgrade ? (this.$t('products.secureUpdate')
      .toString()) : this.isStorageSata ? (this.$t('products.storageModule')
      .toString()) : (this.$t('products.freeTrail')
      .toString()),
      value: 'default',
    });
    if (this.isFreeTrail) {
      const inner : any = {};
      inner['id'] = 'Upgrade Serial Number';
      inner['label'] = 'Upgrade Serial Number';
      inner['value'] = 'Upgrade Serial Number';
      this.secureUpdateOptions.push(inner);
      this.secureUpdate = this.secureUpdateOptions[0].id;
    } else {
      this.secureupgradecontent.content.arrReplacementTypes.forEach((element: any) => {
        const inner : any = {};
        inner['id'] = element.replacementval;
        inner['label'] = element.replacementtype;
        inner['value'] = element.replacementtype;
        this.secureUpdateOptions.push(inner);
      });
      this.secureUpdate = this.secureUpdateOptions[0].id;
      if (this.noOfFields > 1 && this.secureupgradecontent.content.issecureupgrade) {
        this.secureUpdateOptions.splice(2, 1);
      }
      console.warn('created');
      // tslint:disable-next-line:max-line-length
      this.$store.commit('MswProductsStoreModule/mapMutate', { property: this.isSecureUpgrade ? 'secureUpgrade' : this.isStorageSata ? 'storageSata' : 'freeTrailSerNo', key : this.field , value : '' });
      const secureUpdateData1 = this.$store.getters['MswProductsStoreModule/getSecureUpgrade'];
      console.warn(secureUpdateData1);
    }
  }

  secureUpdateChanged() {
    this.$store.commit('MswProductsStoreModule/mapMutate', { property: 'secureUpdateSelected', key : this.field , value : this.secureUpdate });
    if (this.secureUpdate !== 'default') {
      if (this.secureUpdate === 'REPLACEMENTTYPE:SNWLTRADEIN' && this.secureupgradecontent.content.arrTradeInSerials.length === 0) {
        const message: InfoState = { infoType: 'failed', infoMsg: (this.$t('products.tradeInsNotAvailable')
        .toString()) };
        this.$store.commit('enqueueMessage', message);
      } else if (this.secureUpdate === 'REPLACEMENTTYPE:SECAASREPLACEMENT') {
        let secureUpdateData : any ;
        secureUpdateData = [];
        const inner: any = {};
        inner['tradeInSerialnumber'] = 'SECAAS';
        secureUpdateData.push(inner);
        // tslint:disable-next-line:max-line-length
        this.$store.commit('MswProductsStoreModule/mapMutate', { property: 'registerOrTransfer', key: this.field , value: true });
        // this.$emit('secureUpdateSerialNumber', secureUpdateData[0].tradeInSerialnumber);
        this.$store.commit('MswProductsStoreModule/mapMutate', { property: 'secureUpgrade', key : this.field , value : secureUpdateData });
        this.$store.commit('MswProductsStoreModule/mutate', { property: 'secureUpdateData', with: secureUpdateData });
        const secureUpdateData2 = this.$store.getters['MswProductsStoreModule/getSecureUpgrade'];
        console.warn(secureUpdateData2);
      } else if (this.secureUpdate === 'REPLACEMENTTYPE:REMOTEANALYZER') {
        let secureUpdateData : any ;
        secureUpdateData = [];
        const inner: any = {};
        inner['tradeInSerialnumber'] = 'REPORT';
        secureUpdateData.push(inner);
        // tslint:disable-next-line:max-line-length
        this.$store.commit('MswProductsStoreModule/mapMutate', { property: 'registerOrTransfer', key: this.field , value: true });
        // this.$emit('secureUpdateSerialNumber', secureUpdateData[0].tradeInSerialnumber);
        this.$store.commit('MswProductsStoreModule/mapMutate', { property: 'secureUpgrade', key : this.field , value : secureUpdateData });
        this.$store.commit('MswProductsStoreModule/mutate', { property: 'secureUpdateData', with: secureUpdateData });
      } else if (this.secureUpdate === 'REPLACEMENTTYPE:SMA100TRADEUP') {
        this.secUpdatePage = this.secureUpdate;
        this.showSecureUpdateModal = true;
      } else {
        this.secUpdatePage = this.secureUpdate;
        this.showSecureUpdateModal = true;
      }
    } else {
      this.showSecureUpdateModal = false;
    }
  }

  secureUpdateSerialNumber(value : any) {
    this.$emit('skipStep3', true);
    this.secureUpdateSno = value;
  }

  pencilClicked() {
    this.showSecureUpdateModal = true;
  }

  deleteClicked() {
    // tslint:disable-next-line:max-line-length
    this.$store.commit('MswProductsStoreModule/mapMutate', { property: this.isSecureUpgrade ? 'secureUpgrade' : this.isStorageSata ? 'storageSata' : 'freeTrailSerNo' , key : this.field , value : '' });
    this.secureUpdateSno = '';
  }

  clickedDropdown() {
    this.loadData();
    console.warn('secure up updated');
    // this.loadData();
  }
  destroyed() {
    // tslint:disable-next-line:max-line-length
    this.$store.commit('MswProductsStoreModule/mapMutate', { property: this.isSecureUpgrade ? 'secureUpgrade' : this.isStorageSata ? 'storageSata' : 'freeTrailSerNo', key : this.field , value : '' });
    this.secureUpdateSno = '';
    console.warn('destroyed');
  }
}
